export type PossibleApiPrefix = 'api' | 'api2';
